import React, { useState, useEffect,useRef } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Header from "components/Header/Header.js";
import CodeEditor from "components/CodeEditor/CodeEditor.js";
import AnswersList from "components/AnswersList/AnswersList.js";
import LeaderBoard from "components/LeaderBoard/LeaderBoard.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Button from '@material-ui/core/Button';
import styles from "assets/jss/material-kit-react/views/topdev.js";
import Axios from "axios";
import Config from "../../../config.js"
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import HourglassEmptyOutlinedIcon from '@material-ui/icons/HourglassEmptyOutlined';
import MemoryOutlinedIcon from '@material-ui/icons/MemoryOutlined';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import NavigateBeforeOutlinedIcon from '@material-ui/icons/NavigateBeforeOutlined';
import ScoreOutlinedIcon from '@material-ui/icons/ScoreOutlined';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import Chip from '@material-ui/core/Chip';
import ReactHtmlParser from 'react-html-parser';
import swal from 'sweetalert'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { css } from "@emotion/core";
import ClipLoader from "react-spinners/ClipLoader";
import RefreshRoundedIcon from '@material-ui/icons/RefreshRounded';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import Editor from '@monaco-editor/react';
import Ads from "../../Main/Sections/Ads3.js";

import {
    useParams
} from "react-router-dom";
const useStyles = makeStyles(styles);
const override = css`
  position: relative;
    top: 5px;
    margin-right: 10px;
`;
const editor = {
    textAlign: 'left',
    direction: 'ltr',
    marginBottom:"50px"
}
const options = {
    readOnly: true,
    scrollbar: {
        vertical: 'hidden',
        handleMouseWheel: false
    }
  };
 function useInterval(callback, delay) {
  const savedCallback = useRef();
 
  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
export default function UstmbJamChallengePage(props) {
    const classes = useStyles();
    let { ChallengeId } = useParams();
    const [challenges, setChallenges] = useState(null);
    const [question, setQuestion] = useState(0);
    const [openHelp, setOpenHelp] = React.useState(false);
    const [openTransaction, setOpenTransaction] = React.useState(false);
    const [success, setSuccess] = React.useState(null);
    const [refreshLeaderBoard, setRefreshLeaderBoard] = React.useState(false);
    const [diff, setDiff] = React.useState(0);
    const { ...rest } = props;
    const [ButtonEnable, setButtonEnable] = React.useState(false);

    const handleClickOpenHelp = () => {
        setOpenHelp(true);
    };
    const handleCloseHelp = () => {
        setOpenHelp(false);
    };
   useInterval(() => {
                   var d=diff+1;
                     setDiff(d) 
                     if(d>300){
                         setRefreshLeaderBoard(!refreshLeaderBoard);
                         setDiff(0);
                     }
                }, 1000);
    const refreshClick = (event) =>{
        setRefreshLeaderBoard(!refreshLeaderBoard);
        setDiff(0);
    }
    const handleClickOpenTransaction = () => {
        setOpenTransaction(true);
    };
    const handleCloseTransaction = () => {
        setOpenTransaction(false);
    };
    const handleClick = () => {
 
    };

    const check = (cid, qid) => {
        Axios.post(Config.api + "Challenge/GetResult", {
            questionId: qid,
            challengeId: cid
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setSuccess(result.data.data.success)
                
            }).catch((err) => {
                if (err&&err.response&&err.response.status&&err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err&&err.response&&err.response.status&&err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")
            })
    }
    const Send = (code, language) => {
        var encodedString = btoa(code);
        setButtonEnable(false);
        Axios.post(Config.api + "Challenge/Answer", {
            questionId: question.question._id,
            challengeId: ChallengeId,
            languageId: language.code,
            sourceCode: encodedString
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setButtonEnable(true);
                swal("با موفقیت ثبت شد.");
            }).catch((err) => {
                setButtonEnable(true);
                if (err&&err.response&&err.response.status&&err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err&&err.response&&err.response.status&&err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err&&err.response&&err.response.status&&err.response.status === 409) {
                    var s = err.response.data.data.success;
                    setSuccess(s)
                    if (!s)
                        swal("این مورد درحال بررسی است یا به عنوان پاسخ درست ثبت شده است و امکان ارسال پاسخ برای آن وجود ندارد.");
                    else {
                        swal("به این سوال قبلا پاسخ درست داده اید.");
                    }
                }
                else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")
            })
    };

    useEffect(() => {
        Axios.post(Config.api + "Challenge/GetChallengesDetails", {
            filter: "_id=" + ChallengeId + "&populate=questions.question"
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                console.log(result);
                setChallenges(result.data.data);
                setQuestion(result.data.data[0].questions[0])
                check(result.data.data[0]._id, result.data.data[0].questions[0].question._id)
            }).catch((err) => {
                if (err&&err.response&&err.response.status&&err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err&&err.response&&err.response.status&&err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr)
                    swal(err.response.data.message.pr);
                else swal("خطایی رخ داده است.")
            })
    }, []);
    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 30,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax verySmall filter image={require("assets/img/bg8.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>

                        <GridContainer>
                            <GridItem xs={12} sm={12} md={3}>
                                <div className={classes.menu}>
                                    <div className={classes.rightBox}>
                                        <Card className={classes.root} variant="outlined">
                                            <CardContent>
                                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                    ســـــــــــوالات ({challenges && challenges[0].questions.length})
                                                </Typography>
                                                <List component="nav">
                                                    {challenges && challenges[0].questions.map((item, index) => {
                                                        return (
                                                            <ListItem 
                                                                onClick={() => {
                                                                    setQuestion(item)
                                                                    setSuccess(null)
                                                                    check(challenges[0]._id, item.question._id)
                                                                }}
                                                                button
                                                            >
                                                                <ListItemIcon>
                                                                    <NavigateBeforeOutlinedIcon />
                                                                </ListItemIcon>
                                                                <ListItemText className={classes.listitem} primary={item.question.title} />
                                                            </ListItem>
                                                        )
                                                    })}
                                                </List>
                                            </CardContent>
                                            <CardActions>
                                            </CardActions>
                                        </Card>
                                    </div>
                                    <div className={classes.rightBox}>

                                        <Card className={classes.root} variant="outlined">
                                            <CardContent>
                                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                    بــــــــــرترین ها
                                                </Typography>
                                                <LeaderBoard refresh={refreshLeaderBoard} challengeId={ChallengeId} questionId={question&&question.question&&question.question._id}/>
                                            </CardContent>
                                            <CardActions>
                                              <div className={classes.actionButton}>
                                                <div className={classes.center}>
      <Button onClick={refreshClick} size="small" color="textSecondary">
                                 <RefreshRoundedIcon />
          </Button>
      <br />
      <Typography variant="caption"  gutterBottom>
                     {(() => {
                      if(diff<60){
                             return "همین الان"
                         }
                         if(diff<3600)
                         return "بیش از "+Math.floor(diff/60) + " دقیقه پیش"
                         else{
                            return "بیش از "+Math.floor(diff/3600) + " ساعت پیش"
                      }
                     })()}
      </Typography>
                                                </div>
                                                </div>
                                            </CardActions>
                                        </Card>
                                    </div>
                                </div>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={9}>
                                <div className={classes.menu}>
                                    <div className={classes.questionTile}>
                                        <Typography variant="h5" component="h1">
                                            {question ? question.question.title : ""}
                                            {success ?
                                                (<span> (<strong className={classes.successButton}>پاسخ صحیح</strong>) </span>) :
                                                <span>
                                                    <ClipLoader css={override} size={20} color={"#123abc"} loading={(success == null)} />
                                                </span>}
                                        </Typography>
                                    </div>
                                    <div className={classes.chips}>
                                        <Chip
                                        size="small"
                                            icon={<ScoreOutlinedIcon />}
                                            onClick={handleClick}
                                            label={"امتیاز سوال: " + (question ? question.score : "")}
                                            variant="outlined"
                                        />
                                        <Chip
                                        size="small"
                                            icon={<ErrorOutlineOutlinedIcon />}
                                            onClick={handleClick}
                                            label={"سطح دشواری: " + (question ? ((question.level == 1) ? "ساده" : ((question.level == 2) ? "متوسط" : "سخت")) : "")}
                                            variant="outlined"
                                        />
                                        <Chip
                                        size="small"
                                            icon={<MemoryOutlinedIcon />}
                                            onClick={handleClick}
                                            label={"محدودیت حافظه: " + (question ? Math.round(question.question.memoryLimit / 1024) : "") + " کیلوبایت"}
                                            variant="outlined"
                                        />
                                        <Chip
                                        size="small"
                                            icon={<HourglassEmptyOutlinedIcon />}
                                            onClick={handleClick}
                                            label={"محدودیت زمان اجرا: " + (question ? question.question.cpuTimeLimit : "") + " ثانیه"}
                                            variant="outlined"
                                        />
                                        <br />
                                        <br />
                                        <Chip
                                            color="primary"
                                            icon={<SendOutlinedIcon />}
                                            onClick={handleClickOpenTransaction}
                                            label={"گزارش پاسخ های ارسالی"}
                                        />
                                        <Chip
                                            color="primary"
                                            icon={<HelpOutlineIcon />}
                                            onClick={handleClickOpenHelp}
                                            label={"راهنمای ارسال پاسخ"}
                                            variant="outlined"
                                        />
                                    </div>
                                </div>
                                <Divider />
                                <div className={classes.questionText}>
                                    {ReactHtmlParser(question ? question.question.text : "")}
                                </div>
                                <CodeEditor buttonEnable={ButtonEnable}  uniqueId={question&&question._id} onClick={Send} size="400px" languages={question ? question.question.languageIds : []} editorClass={classes.editor} />
                                <br />
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'md'}
                    open={openHelp}
                    onClose={handleCloseHelp}
                    aria-labelledby="max-width-dialog-title"
                >
                    <DialogTitle id="max-width-dialog-title" className={classes.rightToLeft}>آموزش</DialogTitle>
                    <DialogContent>
                        <DialogContentText className={classes.rightToLeft}>
                            استفاده از بخش ارسال کد بسیار ساده است. کافی است از ورودی استاندارد بخوانید و در خروجی استاندار بنویسید.
<br />
متغیرها، نوع و ترتیب آنها در صورت سوال مشخص شده است، کافی ست بخش نمونه را به دقت بخوانید. همچنین نمونه های ارائه شده به شما کمک می کنند تا بتوانید برنامه خود را پیش از ارسال در محیط های برنامه نویسی دیگر تست کنید.
<br />
<br />
هر زبانی را که انتخاب کنید نمونه کد آن زبان برای شما ارائه شده می شود تا شما را راهنمایی کند.
<br />
توجه اکید داشته باشید که، بین print , println تفاوتی وجود دارد. آنچه در خروجی چاپ میکنید باید بدون اسپیس یا اینتر اضافه باشد.
<br />
<br />
به نمونه کد زیر توجه کنید:
<br />
<br />
<div style={editor} >
<Editor
                    height={220}
                    theme={"vs-dark"}
                    value={`#include <iostream>
using namespace std;

int main()
{
    int a;
    cin >> a; //Standard input
    cout << a; //Standard output
    return 0;
}`}
                    language={"cpp"}
                    options={options}
                     />
                    </div>
                    در نمونه کد بالا که به زبان ++C نوشته شده است، از ورودی یک عدد دریافت و همان عدد در خروجی چاپ شده است.
                    <br />
                    <br />
                    کدهای خود را میتوانید در <a href='https://ide.sharifcamp.ir'>کامپایلر آنلاین</a> ما تست کنید.
                    <br />
                    در نهایت هر سوالی داشتید با ما ارتباط بر قرار کنید.

          </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseHelp} color="primary">
                            بستن
          </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'md'}
                    open={openTransaction}
                    onClose={handleCloseTransaction}
                    aria-labelledby="max-width-dialog-title">
                    <DialogTitle id="max-width-dialog-title" className={classes.rightToLeft}>گزارش پاسخ های ارسالی</DialogTitle>
                    <DialogContent>
                        <DialogContentText className={classes.rightToLeft}>
                            <AnswersList refresh={openTransaction} challengeId={ChallengeId} questionId={question&&question.question&&question.question._id}/>
          </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseTransaction} color="primary">
                            بستن
          </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        </div>
    );
}

